<template>
  <header :class="{centered: isCentered}">
    <h2
      class="h4-like"
      v-if="h2"
      v-html="title"
    />
    <h3
      v-else
      v-html="title"
    />

    <span
      v-if="subTitle"
      v-html="subTitle"
    />

    <svg
      v-if="svg"
      @click="isSvgClickable ? clicked() : null"
    >
      <use :xlink:href="`#${svg}`"></use>
    </svg>
  </header>
</template>

<script>
export default {
  name: 'SharedFormHead',
  props: {
    title: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      default: null,
    },
    isCentered: {
      type: Boolean,
      default: true,
    },
    svg: {
      type: String,
      default: '',
    },
    isSvgClickable: {
      type: Boolean,
      default: true,
    },
    h2: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    clicked() {
      this.$emit('clickedSvg')
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../../../../../_src/sass/config/vars';
@import '../../../../../_src/sass/config/mixins';
@import '../../../../../_src/sass/config/responsive';

header {
  color: black;
  margin-bottom: 10px;
  position: relative;
  text-align: left;

  &.centered {
    text-align: center;
  }

  h3,
  h2,
  h4 {
    margin: none;
    padding-bottom: 10px;
    text-align: left;
    //text-transform: uppercase;
  }

  span {
    font-style: italic;

    & ::v-deep strong {
      font-weight: bold;
    }
  }

  svg {
    cursor: pointer;
    height: 15px;
    position: absolute;
    right: 0;
    top: 0;
    width: 15px;
  }
}
</style>
